import {
  useGlobalApiQuery,
  getGlobalAPIHeaders,
} from '@data/global-api-common';
import type { UseQueryResult } from '@utility/checkout-utils';

import { GLOBAL_API_INSTITUTIONS_ENDPOINTS } from '../../constants/endpoints';
import type { GlobalApiInstitutionDetails } from '../../types/institutions';

import type { UseGetGlobalApiInstitutionDetailsParams } from './useGetGlobalApiInstitutionDetails.types';

export function useGetGlobalApiInstitutionDetails({
  authToken,
  institutionId,
  voltApp,
  voltService,
  skip,
}: UseGetGlobalApiInstitutionDetailsParams): UseQueryResult<GlobalApiInstitutionDetails> {
  const { result, error, isError, ...rest } =
    useGlobalApiQuery<GlobalApiInstitutionDetails>({
      url: GLOBAL_API_INSTITUTIONS_ENDPOINTS.getInstitutionDetails(
        institutionId
      ),
      headers: getGlobalAPIHeaders({ authToken, voltApp, voltService }),
      skip,
    });

  return {
    result,
    error,
    isError,
    ...rest,
  };
}
